import { ISODateType } from '@principle-theorem/shared';
import { IClaimableItem } from '../../invoice/healthcare-claim';

export interface IMohReconciledClaimItem extends IClaimableItem {
  approved?: boolean;
  amountPayable?: number;
}

export interface IMohExtendedData {
  items: IMohReconciledClaimItem[];
  amountClaimed: number;
  paymentDate?: ISODateType;
  amountPayable?: number;
}
